import type { ApiConfig } from '../../types'

export const twapFillHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 500,
  order: 'asc',
  range: undefined,
  requiresRange: true,
  type: 'twap-fill-history',
} as const satisfies ApiConfig
